export const countrylist = [
  {
    name: "United States",
    dial_code: "+1",
    code: "US",
    rtl: false,
  },
  {
    name: "Aland Islands",
    dial_code: "+358",
    code: "AX",
    rtl: false,
  },
  {
    name: "Albania",
    dial_code: "+355",
    code: "AL",
    rtl: false,
  },
  {
    name: "Algeria",
    dial_code: "+213",
    code: "DZ",
    rtl: false,
  },
  {
    name: "AmericanSamoa",
    dial_code: "+1 684",
    code: "AS",
    rtl: false,
  },
  {
    name: "Andorra",
    dial_code: "+376",
    code: "AD",
    rtl: false,
  },
  {
    name: "Angola",
    dial_code: "+244",
    code: "AO",
    rtl: false,
  },
  {
    name: "Anguilla",
    dial_code: "+1 264",
    code: "AI",
    rtl: false,
  },
  {
    name: "Antarctica",
    dial_code: "+672",
    code: "AQ",
    rtl: false,
  },
  {
    name: "Antigua and Barbuda",
    dial_code: "+1268",
    code: "AG",
    rtl: false,
  },
  {
    name: "Argentina",
    dial_code: "+54",
    code: "AR",
    rtl: false,
  },
  {
    name: "Armenia",
    dial_code: "+374",
    code: "AM",
    rtl: false,
  },
  {
    name: "Aruba",
    dial_code: "+297",
    code: "AW",
    rtl: false,
  },
  {
    name: "Australia",
    dial_code: "+61",
    code: "AU",
    rtl: false,
  },
  {
    name: "Austria",
    dial_code: "+43",
    code: "AT",
    rtl: false,
  },
  {
    name: "Azerbaijan",
    dial_code: "+994",
    code: "AZ",
    rtl: false,
  },
  {
    name: "Bahamas",
    dial_code: "+1 242",
    code: "BS",
    rtl: false,
  },
  {
    name: "Bahrain",
    dial_code: "+973",
    code: "BH",
    rtl: false,
  },
  {
    name: "Bangladesh",
    dial_code: "+880",
    code: "BD",
    rtl: false,
  },
  {
    name: "Barbados",
    dial_code: "+1 246",
    code: "BB",
    rtl: false,
  },
  {
    name: "Belarus",
    dial_code: "+375",
    code: "BY",
    rtl: false,
  },
  {
    name: "Belgium",
    dial_code: "+32",
    code: "BE",
    rtl: false,
  },
  {
    name: "Belize",
    dial_code: "+501",
    code: "BZ",
    rtl: false,
  },
  {
    name: "Benin",
    dial_code: "+229",
    code: "BJ",
    rtl: false,
  },
  {
    name: "Bermuda",
    dial_code: "+1 441",
    code: "BM",
    rtl: false,
  },
  {
    name: "Bhutan",
    dial_code: "+975",
    code: "BT",
    rtl: false,
  },
  {
    name: "Bolivia, Plurinational State of",
    dial_code: "+591",
    code: "BO",
    rtl: false,
  },
  {
    name: "Bosnia and Herzegovina",
    dial_code: "+387",
    code: "BA",
    rtl: false,
  },
  {
    name: "Botswana",
    dial_code: "+267",
    code: "BW",
    rtl: false,
  },
  {
    name: "Brazil",
    dial_code: "+55",
    code: "BR",
    rtl: false,
  },
  {
    name: "British Indian Ocean Territory",
    dial_code: "+246",
    code: "IO",
    rtl: false,
  },
  {
    name: "Brunei Darussalam",
    dial_code: "+673",
    code: "BN",
    rtl: false,
  },
  {
    name: "Bulgaria",
    dial_code: "+359",
    code: "BG",
    rtl: false,
  },
  {
    name: "Burkina Faso",
    dial_code: "+226",
    code: "BF",
    rtl: false,
  },
  {
    name: "Burundi",
    dial_code: "+257",
    code: "BI",
    rtl: false,
  },
  {
    name: "Cambodia",
    dial_code: "+855",
    code: "KH",
    rtl: false,
  },
  {
    name: "Cameroon",
    dial_code: "+237",
    code: "CM",
    rtl: false,
  },
  {
    name: "Canada",
    dial_code: "+1",
    code: "CA",
    rtl: false,
  },
  {
    name: "Cape Verde",
    dial_code: "+238",
    code: "CV",
    rtl: false,
  },
  {
    name: "Cayman Islands",
    dial_code: "+ 345",
    code: "KY",
    rtl: false,
  },
  {
    name: "Central African Republic",
    dial_code: "+236",
    code: "CF",
    rtl: false,
  },
  {
    name: "Chad",
    dial_code: "+235",
    code: "TD",
    rtl: false,
  },
  {
    name: "Chile",
    dial_code: "+56",
    code: "CL",
    rtl: false,
  },
  {
    name: "China",
    dial_code: "+86",
    code: "CN",
    rtl: false,
  },
  {
    name: "Christmas Island",
    dial_code: "+61",
    code: "CX",
    rtl: false,
  },
  {
    name: "Cocos (Keeling) Islands",
    dial_code: "+61",
    code: "CC",
    rtl: false,
  },
  {
    name: "Colombia",
    dial_code: "+57",
    code: "CO",
    rtl: false,
  },
  {
    name: "Comoros",
    dial_code: "+269",
    code: "KM",
    rtl: false,
  },
  {
    name: "Congo",
    dial_code: "+242",
    code: "CG",
    rtl: false,
  },
  {
    name: "Congo, The Democratic Republic of the Congo",
    dial_code: "+243",
    code: "CD",
    rtl: false,
  },
  {
    name: "Cook Islands",
    dial_code: "+682",
    code: "CK",
    rtl: false,
  },
  {
    name: "Costa Rica",
    dial_code: "+506",
    code: "CR",
    rtl: false,
  },
  {
    name: "Cote d'Ivoire",
    dial_code: "+225",
    code: "CI",
    rtl: false,
  },
  {
    name: "Croatia",
    dial_code: "+385",
    code: "HR",
    rtl: false,
  },
  {
    name: "Cuba",
    dial_code: "+53",
    code: "CU",
    rtl: false,
  },
  {
    name: "Cyprus",
    dial_code: "+357",
    code: "CY",
    rtl: false,
  },
  {
    name: "Czech Republic",
    dial_code: "+420",
    code: "CZ",
    rtl: false,
  },
  {
    name: "Denmark",
    dial_code: "+45",
    code: "DK",
    rtl: false,
  },
  {
    name: "Djibouti",
    dial_code: "+253",
    code: "DJ",
    rtl: false,
  },
  {
    name: "Dominica",
    dial_code: "+1 767",
    code: "DM",
    rtl: false,
  },
  {
    name: "Dominican Republic",
    dial_code: "+1 849",
    code: "DO",
    rtl: false,
  },
  {
    name: "Ecuador",
    dial_code: "+593",
    code: "EC",
    rtl: false,
  },
  {
    name: "Egypt",
    dial_code: "+20",
    code: "EG",
    rtl: false,
  },
  {
    name: "El Salvador",
    dial_code: "+503",
    code: "SV",
    rtl: false,
  },
  {
    name: "Equatorial Guinea",
    dial_code: "+240",
    code: "GQ",
    rtl: false,
  },
  {
    name: "Eritrea",
    dial_code: "+291",
    code: "ER",
    rtl: false,
  },
  {
    name: "Estonia",
    dial_code: "+372",
    code: "EE",
    rtl: false,
  },
  {
    name: "Ethiopia",
    dial_code: "+251",
    code: "ET",
    rtl: false,
  },
  {
    name: "Falkland Islands (Malvinas)",
    dial_code: "+500",
    code: "FK",
    rtl: false,
  },
  {
    name: "Faroe Islands",
    dial_code: "+298",
    code: "FO",
    rtl: false,
  },
  {
    name: "Fiji",
    dial_code: "+679",
    code: "FJ",
    rtl: false,
  },
  {
    name: "Finland",
    dial_code: "+358",
    code: "FI",
    rtl: false,
  },
  {
    name: "France",
    dial_code: "+33",
    code: "FR",
    rtl: false,
  },
  {
    name: "French Guiana",
    dial_code: "+594",
    code: "GF",
    rtl: false,
  },
  {
    name: "French Polynesia",
    dial_code: "+689",
    code: "PF",
    rtl: false,
  },
  {
    name: "Gabon",
    dial_code: "+241",
    code: "GA",
    rtl: false,
  },
  {
    name: "Gambia",
    dial_code: "+220",
    code: "GM",
    rtl: false,
  },
  {
    name: "Georgia",
    dial_code: "+995",
    code: "GE",
    rtl: false,
  },
  {
    name: "Germany",
    dial_code: "+49",
    code: "DE",
    rtl: false,
  },
  {
    name: "Ghana",
    dial_code: "+233",
    code: "GH",
    rtl: false,
  },
  {
    name: "Gibraltar",
    dial_code: "+350",
    code: "GI",
    rtl: false,
  },
  {
    name: "Greece",
    dial_code: "+30",
    code: "GR",
    rtl: false,
  },
  {
    name: "Greenland",
    dial_code: "+299",
    code: "GL",
    rtl: false,
  },
  {
    name: "Grenada",
    dial_code: "+1 473",
    code: "GD",
    rtl: false,
  },
  {
    name: "Guadeloupe",
    dial_code: "+590",
    code: "GP",
    rtl: false,
  },
  {
    name: "Guam",
    dial_code: "+1 671",
    code: "GU",
    rtl: false,
  },
  {
    name: "Guatemala",
    dial_code: "+502",
    code: "GT",
    rtl: false,
  },
  {
    name: "Guernsey",
    dial_code: "+44",
    code: "GG",
    rtl: false,
  },
  {
    name: "Guinea",
    dial_code: "+224",
    code: "GN",
    rtl: false,
  },
  {
    name: "Guinea-Bissau",
    dial_code: "+245",
    code: "GW",
    rtl: false,
  },
  {
    name: "Guyana",
    dial_code: "+595",
    code: "GY",
    rtl: false,
  },
  {
    name: "Haiti",
    dial_code: "+509",
    code: "HT",
    rtl: false,
  },
  {
    name: "Holy See (Vatican City State)",
    dial_code: "+379",
    code: "VA",
    rtl: false,
  },
  {
    name: "Honduras",
    dial_code: "+504",
    code: "HN",
    rtl: false,
  },
  {
    name: "Hong Kong",
    dial_code: "+852",
    code: "HK",
    rtl: false,
  },
  {
    name: "Hungary",
    dial_code: "+36",
    code: "HU",
    rtl: false,
  },
  {
    name: "Iceland",
    dial_code: "+354",
    code: "IS",
    rtl: false,
  },
  {
    name: "India",
    dial_code: "+91",
    code: "IN",
    rtl: false,
  },
  {
    name: "Indonesia",
    dial_code: "+62",
    code: "ID",
    rtl: false,
  },
  {
    name: "Iran, Islamic Republic of Persian Gulf",
    dial_code: "+98",
    code: "IR",
    rtl: false,
  },
  {
    name: "Iraq",
    dial_code: "+964",
    code: "IQ",
    rtl: false,
  },
  {
    name: "Ireland",
    dial_code: "+353",
    code: "IE",
    rtl: false,
  },
  {
    name: "Isle of Man",
    dial_code: "+44",
    code: "IM",
    rtl: false,
  },
  {
    name: "Israel",
    dial_code: "+972",
    code: "IL",
    rtl: false,
  },
  {
    name: "Italy",
    dial_code: "+39",
    code: "IT",
    rtl: false,
  },
  {
    name: "Jamaica",
    dial_code: "+1 876",
    code: "JM",
    rtl: false,
  },
  {
    name: "Japan",
    dial_code: "+81",
    code: "JP",
    rtl: false,
  },
  {
    name: "Jersey",
    dial_code: "+44",
    code: "JE",
    rtl: false,
  },
  {
    name: "Jordan",
    dial_code: "+962",
    code: "JO",
    rtl: false,
  },
  {
    name: "Kazakhstan",
    dial_code: "+7 7",
    code: "KZ",
    rtl: false,
  },
  {
    name: "Kenya",
    dial_code: "+254",
    code: "KE",
    rtl: false,
  },
  {
    name: "Kiribati",
    dial_code: "+686",
    code: "KI",
    rtl: false,
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    dial_code: "+850",
    code: "KP",
    rtl: false,
  },
  {
    name: "Korea, Republic of South Korea",
    dial_code: "+82",
    code: "KR",
    rtl: false,
  },
  {
    name: "Kuwait",
    dial_code: "+965",
    code: "KW",
    rtl: false,
  },
  {
    name: "Kyrgyzstan",
    dial_code: "+996",
    code: "KG",
    rtl: false,
  },
  {
    name: "Laos",
    dial_code: "+856",
    code: "LA",
    rtl: false,
  },
  {
    name: "Latvia",
    dial_code: "+371",
    code: "LV",
    rtl: false,
  },
  {
    name: "Lebanon",
    dial_code: "+961",
    code: "LB",
    rtl: false,
  },
  {
    name: "Lesotho",
    dial_code: "+266",
    code: "LS",
    rtl: false,
  },
  {
    name: "Liberia",
    dial_code: "+231",
    code: "LR",
    rtl: false,
  },
  {
    name: "Libyan Arab Jamahiriya",
    dial_code: "+218",
    code: "LY",
    rtl: false,
  },
  {
    name: "Liechtenstein",
    dial_code: "+423",
    code: "LI",
    rtl: false,
  },
  {
    name: "Lithuania",
    dial_code: "+370",
    code: "LT",
    rtl: false,
  },
  {
    name: "Luxembourg",
    dial_code: "+352",
    code: "LU",
    rtl: false,
  },
  {
    name: "Macao",
    dial_code: "+853",
    code: "MO",
    rtl: false,
  },
  {
    name: "Macedonia",
    dial_code: "+389",
    code: "MK",
    rtl: false,
  },
  {
    name: "Madagascar",
    dial_code: "+261",
    code: "MG",
    rtl: false,
  },
  {
    name: "Malawi",
    dial_code: "+265",
    code: "MW",
    rtl: false,
  },
  {
    name: "Malaysia",
    dial_code: "+60",
    code: "MY",
    rtl: false,
  },
  {
    name: "Maldives",
    dial_code: "+960",
    code: "MV",
    rtl: false,
  },
  {
    name: "Mali",
    dial_code: "+223",
    code: "ML",
    rtl: false,
  },
  {
    name: "Malta",
    dial_code: "+356",
    code: "MT",
    rtl: false,
  },
  {
    name: "Marshall Islands",
    dial_code: "+692",
    code: "MH",
    rtl: false,
  },
  {
    name: "Martinique",
    dial_code: "+596",
    code: "MQ",
    rtl: false,
  },
  {
    name: "Mauritania",
    dial_code: "+222",
    code: "MR",
    rtl: false,
  },
  {
    name: "Mauritius",
    dial_code: "+230",
    code: "MU",
    rtl: false,
  },
  {
    name: "Mayotte",
    dial_code: "+262",
    code: "YT",
    rtl: false,
  },
  {
    name: "Mexico",
    dial_code: "+52",
    code: "MX",
    rtl: false,
  },
  {
    name: "Micronesia, Federated States of Micronesia",
    dial_code: "+691",
    code: "FM",
    rtl: false,
  },
  {
    name: "Moldova",
    dial_code: "+373",
    code: "MD",
    rtl: false,
  },
  {
    name: "Monaco",
    dial_code: "+377",
    code: "MC",
    rtl: false,
  },
  {
    name: "Mongolia",
    dial_code: "+976",
    code: "MN",
    rtl: false,
  },
  {
    name: "Montenegro",
    dial_code: "+382",
    code: "ME",
    rtl: false,
  },
  {
    name: "Montserrat",
    dial_code: "+1664",
    code: "MS",
    rtl: false,
  },
  {
    name: "Morocco",
    dial_code: "+212",
    code: "MA",
    rtl: false,
  },
  {
    name: "Mozambique",
    dial_code: "+258",
    code: "MZ",
    rtl: false,
  },
  {
    name: "Myanmar",
    dial_code: "+95",
    code: "MM",
    rtl: false,
  },
  {
    name: "Namibia",
    dial_code: "+264",
    code: "NA",
    rtl: false,
  },
  {
    name: "Nauru",
    dial_code: "+674",
    code: "NR",
    rtl: false,
  },
  {
    name: "Nepal",
    dial_code: "+977",
    code: "NP",
    rtl: false,
  },
  {
    name: "Netherlands",
    dial_code: "+31",
    code: "NL",
    rtl: false,
  },
  {
    name: "Netherlands Antilles",
    dial_code: "+599",
    code: "AN",
    rtl: false,
  },
  {
    name: "New Caledonia",
    dial_code: "+687",
    code: "NC",
    rtl: false,
  },
  {
    name: "New Zealand",
    dial_code: "+64",
    code: "NZ",
    rtl: false,
  },
  {
    name: "Nicaragua",
    dial_code: "+505",
    code: "NI",
    rtl: false,
  },
  {
    name: "Niger",
    dial_code: "+227",
    code: "NE",
    rtl: false,
  },
  {
    name: "Nigeria",
    dial_code: "+234",
    code: "NG",
    rtl: false,
  },
  {
    name: "Niue",
    dial_code: "+683",
    code: "NU",
    rtl: false,
  },
  {
    name: "Norfolk Island",
    dial_code: "+672",
    code: "NF",
    rtl: false,
  },
  {
    name: "Northern Mariana Islands",
    dial_code: "+1 670",
    code: "MP",
    rtl: false,
  },
  {
    name: "Norway",
    dial_code: "+47",
    code: "NO",
    rtl: false,
  },
  {
    name: "Oman",
    dial_code: "+968",
    code: "OM",
    rtl: false,
  },
  {
    name: "Pakistan",
    dial_code: "+92",
    code: "PK",
    rtl: false,
  },
  {
    name: "Palau",
    dial_code: "+680",
    code: "PW",
    rtl: false,
  },
  {
    name: "Palestinian Territory, Occupied",
    dial_code: "+970",
    code: "PS",
    rtl: false,
  },
  {
    name: "Panama",
    dial_code: "+507",
    code: "PA",
    rtl: false,
  },
  {
    name: "Papua New Guinea",
    dial_code: "+675",
    code: "PG",
    rtl: false,
  },
  {
    name: "Paraguay",
    dial_code: "+595",
    code: "PY",
    rtl: false,
  },
  {
    name: "Peru",
    dial_code: "+51",
    code: "PE",
    rtl: false,
  },
  {
    name: "Philippines",
    dial_code: "+63",
    code: "PH",
    rtl: false,
  },
  {
    name: "Pitcairn",
    dial_code: "+872",
    code: "PN",
    rtl: false,
  },
  {
    name: "Poland",
    dial_code: "+48",
    code: "PL",
    rtl: false,
  },
  {
    name: "Portugal",
    dial_code: "+351",
    code: "PT",
    rtl: false,
  },
  {
    name: "Puerto Rico",
    dial_code: "+1 939",
    code: "PR",
    rtl: false,
  },
  {
    name: "Qatar",
    dial_code: "+974",
    code: "QA",
    rtl: false,
  },
  {
    name: "Romania",
    dial_code: "+40",
    code: "RO",
    rtl: false,
  },
  {
    name: "Russia",
    dial_code: "+7",
    code: "RU",
    rtl: false,
  },
  {
    name: "Rwanda",
    dial_code: "+250",
    code: "RW",
    rtl: false,
  },
  {
    name: "Reunion",
    dial_code: "+262",
    code: "RE",
    rtl: false,
  },
  {
    name: "Saint Barthelemy",
    dial_code: "+590",
    code: "BL",
    rtl: false,
  },
  {
    name: "Saint Helena, Ascension and Tristan Da Cunha",
    dial_code: "+290",
    code: "SH",
    rtl: false,
  },
  {
    name: "Saint Kitts and Nevis",
    dial_code: "+1 869",
    code: "KN",
    rtl: false,
  },
  {
    name: "Saint Lucia",
    dial_code: "+1 758",
    code: "LC",
    rtl: false,
  },
  {
    name: "Saint Martin",
    dial_code: "+590",
    code: "MF",
    rtl: false,
  },
  {
    name: "Saint Pierre and Miquelon",
    dial_code: "+508",
    code: "PM",
    rtl: false,
  },
  {
    name: "Saint Vincent and the Grenadines",
    dial_code: "+1 784",
    code: "VC",
    rtl: false,
  },
  {
    name: "Samoa",
    dial_code: "+685",
    code: "WS",
    rtl: false,
  },
  {
    name: "San Marino",
    dial_code: "+378",
    code: "SM",
    rtl: false,
  },
  {
    name: "Sao Tome and Principe",
    dial_code: "+239",
    code: "ST",
    rtl: false,
  },
  {
    name: "Saudi Arabia",
    dial_code: "+966",
    code: "SA",
    rtl: false,
  },
  {
    name: "Senegal",
    dial_code: "+221",
    code: "SN",
    rtl: false,
  },
  {
    name: "Serbia",
    dial_code: "+381",
    code: "RS",
    rtl: false,
  },
  {
    name: "Seychelles",
    dial_code: "+248",
    code: "SC",
    rtl: false,
  },
  {
    name: "Sierra Leone",
    dial_code: "+232",
    code: "SL",
    rtl: false,
  },
  {
    name: "Singapore",
    dial_code: "+65",
    code: "SG",
    rtl: false,
  },
  {
    name: "Slovakia",
    dial_code: "+421",
    code: "SK",
    rtl: false,
  },
  {
    name: "Slovenia",
    dial_code: "+386",
    code: "SI",
    rtl: false,
  },
  {
    name: "Solomon Islands",
    dial_code: "+677",
    code: "SB",
    rtl: false,
  },
  {
    name: "Somalia",
    dial_code: "+252",
    code: "SO",
    rtl: false,
  },
  {
    name: "South Africa",
    dial_code: "+27",
    code: "ZA",
    rtl: false,
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    dial_code: "+500",
    code: "GS",
    rtl: false,
  },
  {
    name: "Spain",
    dial_code: "+34",
    code: "ES",
    rtl: false,
  },
  {
    name: "Sri Lanka",
    dial_code: "+94",
    code: "LK",
    rtl: false,
  },
  {
    name: "Sudan",
    dial_code: "+249",
    code: "SD",
    rtl: false,
  },
  {
    name: "Suriname",
    dial_code: "+597",
    code: "SR",
    rtl: false,
  },
  {
    name: "Svalbard and Jan Mayen",
    dial_code: "+47",
    code: "SJ",
    rtl: false,
  },
  {
    name: "Swaziland",
    dial_code: "+268",
    code: "SZ",
    rtl: false,
  },
  {
    name: "Sweden",
    dial_code: "+46",
    code: "SE",
    rtl: false,
  },
  {
    name: "Switzerland",
    dial_code: "+41",
    code: "CH",
    rtl: false,
  },
  {
    name: "Syrian Arab Republic",
    dial_code: "+963",
    code: "SY",
    rtl: false,
  },
  {
    name: "Taiwan",
    dial_code: "+886",
    code: "TW",
    rtl: false,
  },
  {
    name: "Tajikistan",
    dial_code: "+992",
    code: "TJ",
    rtl: false,
  },
  {
    name: "Tanzania, United Republic of Tanzania",
    dial_code: "+255",
    code: "TZ",
    rtl: false,
  },
  {
    name: "Thailand",
    dial_code: "+66",
    code: "TH",
    rtl: false,
  },
  {
    name: "Timor-Leste",
    dial_code: "+670",
    code: "TL",
    rtl: false,
  },
  {
    name: "Togo",
    dial_code: "+228",
    code: "TG",
    rtl: false,
  },
  {
    name: "Tokelau",
    dial_code: "+690",
    code: "TK",
    rtl: false,
  },
  {
    name: "Tonga",
    dial_code: "+676",
    code: "TO",
    rtl: false,
  },
  {
    name: "Trinidad and Tobago",
    dial_code: "+1 868",
    code: "TT",
    rtl: false,
  },
  {
    name: "Tunisia",
    dial_code: "+216",
    code: "TN",
    rtl: false,
  },
  {
    name: "Turkey",
    dial_code: "+90",
    code: "TR",
    rtl: false,
  },
  {
    name: "Turkmenistan",
    dial_code: "+993",
    code: "TM",
    rtl: false,
  },
  {
    name: "Turks and Caicos Islands",
    dial_code: "+1 649",
    code: "TC",
    rtl: false,
  },
  {
    name: "Tuvalu",
    dial_code: "+688",
    code: "TV",
    rtl: false,
  },
  {
    name: "Uganda",
    dial_code: "+256",
    code: "UG",
    rtl: false,
  },
  {
    name: "Ukraine",
    dial_code: "+380",
    code: "UA",
    rtl: false,
  },
  {
    name: "United Arab Emirates",
    dial_code: "+971",
    code: "AE",
    rtl: false,
  },
  {
    name: "United Kingdom",
    dial_code: "+44",
    code: "GB",
    rtl: false,
  },
  {
    name: "United States",
    dial_code: "+1",
    code: "US",
    rtl: false,
  },
  {
    name: "Uruguay",
    dial_code: "+598",
    code: "UY",
    rtl: false,
  },
  {
    name: "Uzbekistan",
    dial_code: "+998",
    code: "UZ",
    rtl: false,
  },
  {
    name: "Vanuatu",
    dial_code: "+678",
    code: "VU",
    rtl: false,
  },
  {
    name: "Venezuela, Bolivarian Republic of Venezuela",
    dial_code: "+58",
    code: "VE",
    rtl: false,
  },
  {
    name: "Vietnam",
    dial_code: "+84",
    code: "VN",
    rtl: false,
  },
  {
    name: "Virgin Islands, British",
    dial_code: "+1 284",
    code: "VG",
    rtl: false,
  },
  {
    name: "Virgin Islands, U.S.",
    dial_code: "+1 340",
    code: "VI",
    rtl: false,
  },
  {
    name: "Wallis and Futuna",
    dial_code: "+681",
    code: "WF",
    rtl: false,
  },
  {
    name: "Yemen",
    dial_code: "+967",
    code: "YE",
    rtl: false,
  },
  {
    name: "Zambia",
    dial_code: "+260",
    code: "ZM",
    rtl: false,
  },
  {
    name: "Zimbabwe",
    dial_code: "+263",
    code: "ZW",
    rtl: false,
  },
];
